import { __decorate } from "tslib";
import { Pipe } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
let SafeHtmlPipe = class SafeHtmlPipe {
    sanitizer;
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value) {
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
    static ctorParameters = () => [
        { type: DomSanitizer }
    ];
};
SafeHtmlPipe = __decorate([
    Pipe({
        name: "safeHtml",
    })
], SafeHtmlPipe);
export { SafeHtmlPipe };
